import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './error-pages.css';

export function NotFound(): JSX.Element {
  useEffect(() => {
    document.title = '404 - Page Not Found - Kibo Hub';
  }, []);

  return (
    <div className="error-page">
      <div className="error-content">
        <h1 className="error-code">404</h1>
        <h2 className="error-title">Page Not Found</h2>
        <p className="error-description">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="error-actions">
          <Link to="/" className="btn btn-primary">
            Go to Dashboard
          </Link>
          <button onClick={() => window.history.back()} className="btn btn-outline">
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
